import classnames from 'classnames';

import styles from './Loader.module.scss';
import { LoaderDeprecatedProps } from './Loader.types';

function getDynamicStyle({ heightInRem }: LoaderDeprecatedProps) {
  return {
    containerStyle: {
      width: `${2 * heightInRem}rem`,
      height: `${heightInRem}rem`,
      padding: `${0.33 * heightInRem}rem`,
      borderRadius: `${heightInRem}rem`,
    },
    bounceStyle: {
      width: `${0.42 * heightInRem}rem`,
      height: `${0.42 * heightInRem}rem`,
    },
  };
}

export const LoaderDeprecated = (props: LoaderDeprecatedProps) => {
  const { containerStyle, bounceStyle } = getDynamicStyle(props);
  return (
    <div
      className={classnames(styles.container, props.className, {
        [styles.darkMode]: props.darkMode,
        [styles.lightMode]: !props.darkMode,
      })}
      style={containerStyle}
    >
      <div className={styles.bounce1} style={bounceStyle} />
      <div className={styles.bounce2} style={bounceStyle} />
      <div style={bounceStyle} />
    </div>
  );
};
